import React from 'react';
import { AccountManagementProps } from './types';

const AccountManagement: React.FC<AccountManagementProps> = ({
  onDeactivateAccount,
  onDeleteAccount
}) => {
  return (
    <div className="mt-8 border-t pt-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Account Management
      </h2>

      <p className="text-gray-600 mb-6">
        Options to manage your RentSmart account. Please note that these actions
        cannot be undone easily.
      </p>

      <div className="space-y-4 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row justify-center">
        <button
          onClick={onDeactivateAccount}
          className="px-6 py-2 border border-yellow-500 text-yellow-600 rounded-lg hover:bg-yellow-50 transition-colors duration-300"
        >
          Deactivate Account
        </button>

        <button
          onClick={onDeleteAccount}
          className="px-6 py-2 border border-red-500 text-red-600 rounded-lg hover:bg-red-50 transition-colors duration-300"
        >
          Delete Account Permanently
        </button>
      </div>
    </div>
  );
};

export default AccountManagement;
